import { SHARE_TYPE } from '../containers/Share/constants'

export default {
  NO_RESULT: 'No Results Found',
  WENT_WRONG: 'Something went wrong, try again later',
  DISABLE_SOURCE_MODE: 'Please disable Source mode in the Body Editor',
  MAIL_CONTENT_NOT_SCANNED:
    'Mail content is not scanned by IRONSCALES due to company policy constraints',
  SESSION_EXPIRED: 'Your session has timed out, please log in again',
}

export const getShareSuccessToastText = (shareType) => {
  if (Object.values(SHARE_TYPE.REPORT).includes(shareType)) return 'The Report has been sent'
  else return 'Action has been completed successfully'
}
